import { createAction } from 'redux-actions';
import {
  PapiDaUserProfileInitStats,
  PapiDaUserProfileStatsMyContent,
} from '@wix/da-types-papi';
import { StatsTimePeriod, MySubmissionsSortBy } from '../../types/statsSection';

export const setStats = createAction<PapiDaUserProfileInitStats['sectionData']>(
  'STATS_SECTION/SET_STATS'
);

export const setMySubmissionsStats = createAction<
  PapiDaUserProfileStatsMyContent['myContent']
>('STATS_SECTION/SET_MY_SUBMISSIONS_STATS');

export const setTimePeriod = createAction<StatsTimePeriod>(
  'STATS_SECTION/SET_TIME_PERIOD'
);

export const setMySubmissionsSortBy = createAction<MySubmissionsSortBy>(
  'STATS_SECTION/SET_MY_SUBMISSIONS_SORT_BY'
);

export const setMySubmissionsIsLoading = createAction<boolean>(
  'STATS_SECTION/SET_MY_SUBMISSIONS_IS_LOADING'
);
